import { Component } from 'react';

import { OnChangeType, ValueItem } from 'types/functions';
import { checkDifferent } from 'utils/formHandlers';
import { translate } from 'utils/translate';

interface DirectionSelectProps {
    value: ValueItem[];
    range: ValueItem[];

    label: string;
    name: string;
    onChange: OnChangeType;
}

interface DirectionSelectState {
    min: number;
    max: number;

    deactive: number[];
    value: number[];
    range: number[];
}

const fullRange = [
    {
        index: 1,
        lte: 45,
        gte: 0,
    },
    {
        index: 2,
        lte: 90,
        gte: 45,
    },
    {
        index: 3,
        lte: 135,
        gte: 90,
    },
    {
        index: 4,
        lte: 180,
        gte: 135,
    },
    {
        index: 5,
        lte: 225,
        gte: 180,
    },
    {
        index: 6,
        lte: 270,
        gte: 225,
    },
    {
        index: 7,
        lte: 315,
        gte: 270,
    },
    {
        index: 8,
        lte: 360,
        gte: 315,
    },
];

class DirectionSelect extends Component<DirectionSelectProps, DirectionSelectState> {
    constructor(props: DirectionSelectProps) {
        super(props);
        this.state = {
            min: 0,
            max: 360,
            deactive: [],
            value: [],
            range: [],
        };
    }

    static getDerivedStateFromProps(nextProps: DirectionSelectProps, prevState: DirectionSelectState) {
        if (checkDifferent(prevState.value, nextProps.value)) {
            return {
                deactive: fullRange
                    .filter((x) => {
                        return !nextProps.range
                            .map((y) => {
                                return y.index;
                            })
                            .includes(x.index);
                    })
                    .map((x) => {
                        return x.index;
                    }),
                range: nextProps.range.map((x) => {
                    return x.index;
                }),
                value: nextProps.value.map((x) => {
                    return x.index;
                }),
            };
        }
        return null;
    }

    selectDirection = (id: number) => {
        if (this.state.deactive.includes(id)) {
            return;
        }
        const value = [...this.state.value];

        if (value.includes(id)) {
            value.splice(this.state.value.indexOf(id), 1);
        } else {
            value.push(id);
        }

        this.props.onChange(
            this.props.name,
            fullRange.filter((x) => {
                return value.includes(x.index);
            })
        );
    };

    render() {
        return (
            <div>
                <div className="block font-medium leading-5 text-gray-700 no-select capitalize">
                    {this.props.label} : {translate('from')}
                    <span className="cursor-pointer mx-1 ">{this.state.min}</span>
                    {translate('to')}
                    <span className="cursor-pointer mx-1">{this.state.max}</span>
                </div>

                <svg className="ml-auto mr-auto w-24" viewBox="0 0 110 110">
                    {[3, 4, 5, 6, 7, 8, 1, 2].map((id) => (
                        <path
                            key={id}
                            fill={
                                this.state.deactive.includes(id)
                                    ? '#6d6d6d'
                                    : this.state.value.includes(id)
                                    ? '#3182ce'
                                    : '#dddddd'
                            }
                            onClick={() => {
                                this.selectDirection(id);
                            }}
                            d={this.getPathData(id)}
                        />
                    ))}
                </svg>
            </div>
        );
    }

    private getPathData(id: number): string {
        const pathData: { [key: number]: string } = {
            3: 'M55,55 L105,55 A50,50 0 0,1 90.35533905932738,90.35533905932738z',
            4: 'M55,55 L90.35533905932738,90.35533905932738 A50,50 0 0,1 55,105z',
            5: 'M55,55 L55,105 A50,50 0 0,1 19.64466094067263,90.35533905932738z',
            6: 'M55,55 L19.64466094067263,90.35533905932738 A50,50 0 0,1 5,55.00000000000001z',
            7: 'M55,55 L5,55.00000000000001 A50,50 0 0,1 19.644660940672615,19.64466094067263z',
            8: 'M55,55 L19.644660940672615,19.64466094067263 A50,50 0 0,1 54.99999999999999,5z',
            1: 'M55,55 L54.99999999999999,5 A50,50 0 0,1 90.35533905932738,19.644660940672615z',
            2: 'M55,55 L90.35533905932738,19.644660940672615 A50,50 0 0,1 105,54.999999999999986z',
        };
        return pathData[id];
    }
}

export default DirectionSelect;
